import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { PlayingCard } from "./PlayingCard";

export const SortableCard = React.memo(function SortableCard({
  id, card, selected, onClick, size = "md", testId, disabled = false, data, ghosted = false,
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id, data, disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging || ghosted ? 0.3 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className="touch-none shrink-0"
    >
      <PlayingCard
        card={card}
        selected={selected}
        onClick={onClick}
        size={size}
        testId={testId}
        disabled={disabled}
      />
    </div>
  );
});

export default SortableCard;
